import { render, staticRenderFns } from "./main.vue?vue&type=template&id=f8d66150"
var script = {}
import style0 from "./main.vue?vue&type=style&index=0&id=f8d66150&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports